import React, { createContext, useState, useEffect } from 'react';
import FullWidthProducts from './components/pages/fullWidthCardLayout';
import HalfWidthProducts from './components/pages/halfWidthCardLayout';
import Zendesk from './components/zendesk';
import HelpdeskLink from './components/helpdesk';
import Overlay from './components/overlay';
import './style.css';
import Footer from './components/footer';
// variables
const base = window.post_template;
const productLayoutOption = base?.checkout_v3_products?.checkout_v3_products_layout;
const complianceMode =
	(window.isMobile == false && window.msg?.enable_compliance_version_in_desktop) ||
	(window.isMobile == true && window.msg?.enable_compliance_version_in_mobile);
const useZendesk = base?.checkout_v3_footer.checkout_v3_footer_zendesk;
const directCheck = window.msg?.clean_checkout_if_direct_customer && window.directCheck;
const products = window.products;
const fallbacks = base?.checkout_v3_products?.checkout_v3_products_fallbacks;

const mappedProducts = products?.map((product) => {
	const fallback =
		fallbacks &&
		fallbacks.filter((fallback) => {
			return fallback?.product_quantity == product.amount;
		});
	if (fallback.length > 0) {
		return {
			...product,
			image: { ...product.image, url: fallback[0]?.product_image },
		};
	} else {
		return product;
	}
});

// checkout context declaration
const TemplateContext = createContext(null);
const containerClasses = productLayoutOption === 'full' ? 'contentContainer contentContainer--alt' : 'contentContainer';

const Layout = () => {
	const [templateContext, setTemplateContext] = useState({});

	useEffect(() => {
		const primaryProduct = window.products?.filter((item) => {
			return item.best_seller == true;
		});

		const warrantyState = window.productData.add_warranty_for_product
			? window.productData?.preselect_warranty
			: false;

		setTemplateContext({
			config: {
				product: { ...primaryProduct[0] },
				campaignId: window.productData?.konnektive_campaign_id,
				nextStep: window.productData?.next_page_on_success,
				warrantyState: directCheck ? false : warrantyState,
				isWarrantySelected: window.productData.add_warranty_for_product,
				warrantyTexts: window.productData?.warranty_texts,
			},
			showPopup: window.productData?.show_popover,
			popupClicked: false,
			displayPopup: false,
			paymentMethod: 'card',
			isLoading: false,
			outOfStockMode: window.post_template?.checkout_v3_outofstockMode,
			complianceMode: complianceMode,
		});
	}, []);

	return (
		<TemplateContext.Provider value={[templateContext, setTemplateContext]}>
			{productLayoutOption == 'full' ? (
				<FullWidthProducts
					compliance={complianceMode}
					base={base}
					containerClass={containerClasses}
					products={mappedProducts}
				/>
			) : (
				<HalfWidthProducts
					compliance={complianceMode}
					base={base}
					containerClass={containerClasses}
					products={mappedProducts}
				/>
			)}
			<Footer {...base?.checkout_v3_footer} />
			{((templateContext.displayPopup && !templateContext.popupClicked) || templateContext.isLoading) && (
				<Overlay loading={templateContext?.isLoading} paymentMethod={templateContext?.paymentMethod} />
			)}
			{useZendesk ? <Zendesk /> : <HelpdeskLink />}
		</TemplateContext.Provider>
	);
};

export { Layout, TemplateContext };
